<ngb-carousel *ngIf="slides" [showNavigationArrows]="false">
    <ng-template *ngFor="let slide of slides" ngbSlide>
        <div class="picsum-img-wrapper">
            <img [src]="slide.img" class="w-100" alt="">
        </div>
    </ng-template>
</ngb-carousel>